module.exports = __webpack_public_path__ + "img/input_data_animation.0e84991b.png";